import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateFormChanges } from '../../redux/actions';
import { showAlert } from '../../utils/helpers/toastify';
import { toastType, idleSessionTimeout } from '../../constants/app.constants';
import { loginActionTypes, unsavedFormChangesActionTypes } from '../../redux/actionTypes';
import { socket } from '../service';

const useCrossTabIdleLogout = (isLoggedIn, history) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isLoggedIn) return;

    const updateActivity = () => {
      localStorage.setItem('lastActivity', Date.now().toString());
    };

    const activityEvents = ['click', 'mousemove', 'keydown', 'scroll'];
    activityEvents.forEach((event) => window.addEventListener(event, updateActivity));
    updateActivity(); // Initial set
    socket.initiateSocket();

    const checkIdle = () => {
      const lastActivity = parseInt(localStorage.getItem('lastActivity') || '0', 10);
      const now = Date.now();
      const diffMinutes = now - lastActivity;

      if (diffMinutes > idleSessionTimeout.milliseconds) {
        logoutAcrossTabs();
      }
    };

    const logoutAcrossTabs = () => {
      dispatch(updateFormChanges(unsavedFormChangesActionTypes.RESET_FORM_CHANGES));
      showAlert({ type: toastType.info, message: idleSessionTimeout.message });
      dispatch({ type: loginActionTypes.LOGOUT });
      localStorage.setItem('logout', Date.now().toString()); // notify other tabs
      if (history) history.push('/');
    };

    // Check inactivity every 1 min
    const intervalId = setInterval(checkIdle, 5 * 1000);

    // Logout if another tab triggers logout
    const handleStorage = (e) => {
      if (e.key === 'logout') {
        dispatch({ type: loginActionTypes.LOGOUT });
        if (history) history.push('/');
      }
    };
    window.addEventListener('storage', handleStorage);

    return () => {
      activityEvents.forEach((event) => window.removeEventListener(event, updateActivity));
      window.removeEventListener('storage', handleStorage);
      clearInterval(intervalId);
      socket.removeListener();
    };
  }, [isLoggedIn]);
};

export default useCrossTabIdleLogout;
